import { getEnvVariable } from "@appcharge/shared-ui";

export const isProdEnv = () => {
    return getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) === 'prod' || getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) === 'production';
};